import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { USER_RANK_ADMIN, USER_RANK_FACILITATOR } from 'components/permissions/types';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { LANG_OPTION_EN, LANG_OPTION_ET, LANG_OPTION_RU, LANG_SERVICE_DEFAULT } from 'services/LanguageService/languageService.types';
import clsx from 'clsx';
import { locSetLanguage } from '../../../../redux/actions/localization.actions';
UserNavigationMenu.propTypes = {
    userRank: PropTypes.string.isRequired,
    logoutRequest: PropTypes.func.isRequired,
    onItemClick: PropTypes.func
};
export default function UserNavigationMenu(_a) {
    var userRank = _a.userRank, logoutRequest = _a.logoutRequest, _b = _a.onItemClick, onItemClick = _b === void 0 ? function () { } : _b;
    var dispatch = useDispatch();
    var i18n = useTranslation().i18n;
    var currentLang = useSelector(function (state) { return state.localization.language || LANG_SERVICE_DEFAULT; });
    function setLanguage(lang) {
        dispatch(locSetLanguage(lang, i18n));
    }
    return (React.createElement("ul", { className: "list-styles-clear" },
        userRank === USER_RANK_ADMIN ? (React.createElement("li", null,
            React.createElement(Link, { onClick: function () { return onItemClick(); }, to: "/admin" },
                React.createElement(Trans, { i18nKey: "admin" })))) : null,
        (userRank === USER_RANK_ADMIN || userRank === USER_RANK_FACILITATOR) ? (React.createElement("li", null,
            React.createElement(Link, { onClick: function () { return onItemClick(); }, to: "/facilitator/games" },
                React.createElement(Trans, { i18nKey: "games" })))) : null,
        React.createElement("li", null,
            React.createElement("div", { className: "lang-switch" }, [
                { lang: LANG_OPTION_ET, label: 'et' },
                { lang: LANG_OPTION_EN, label: 'en' },
                { lang: LANG_OPTION_RU, label: 'ru' }
            ].map(function (_a) {
                var lang = _a.lang, label = _a.label;
                return (React.createElement("button", { key: lang, className: clsx(['lang-switch__item', currentLang === lang && 'lang-switch__item--active']), onClick: function () { return setLanguage(lang); } }, label));
            }))),
        React.createElement("li", null,
            React.createElement("button", { className: "main-button main-button--lg main-button--hollow", onClick: function () { return logoutRequest(); } },
                React.createElement(Trans, { i18nKey: "logout" })))));
}
